import type { RoutePoint, Track } from '@/types/tour'

type ImportedTrack = Pick<Track, 'clientId' | 'segments'>

function getTrackBoundaryPoints(track: ImportedTrack) {
  const segmentsWithPoints = track.segments.filter((segment) => segment.points.length > 0)
  if (segmentsWithPoints.length === 0) return null

  const firstSegment = segmentsWithPoints[0]
  const lastSegment = segmentsWithPoints[segmentsWithPoints.length - 1]
  const start = firstSegment.points[0]
  const end = lastSegment.points[lastSegment.points.length - 1]

  if (!start || !end) return null
  return { start, end }
}

export function ensureImportedRoutePoints(
  routePoints: RoutePoint[],
  tracks: ImportedTrack[],
  createId: () => string,
): RoutePoint[] {
  if (routePoints.length > 0) return routePoints

  return tracks.flatMap((track) => {
    const boundaryPoints = getTrackBoundaryPoints(track)
    if (!boundaryPoints) return []

    const trackClientId = track.clientId
    return [
      {
        clientId: createId(),
        lat: boundaryPoints.start.lat,
        lon: boundaryPoints.start.lon,
        ele: boundaryPoints.start.ele,
        name: 'Start',
        order: 0,
        trackClientId,
      },
      {
        clientId: createId(),
        lat: boundaryPoints.end.lat,
        lon: boundaryPoints.end.lon,
        ele: boundaryPoints.end.ele,
        name: 'End',
        order: 1,
        trackClientId,
      },
    ]
  })
}
